import React, { useEffect, useState } from "react";

import { useHistory, useParams } from "react-router";

import { isBefore, isAfter, parse, isValid, format } from "date-fns";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { Flex, Button, Box } from "@chakra-ui/react";

import EstatutoEntidade from "./EstatutoEntidade";
import EntidadeGestora from "./EntidadeGestora";
import SupervisaoOGMunicipal from "./SupervisaoOGMunicipal";
import SupervisaoExterna from "./SupervisaoExterna";
import LoadingSpinner from "../../../../components/LoadingSpinner";

import GestaoSAService from "../../../../../main/services/GestaoSAService";
import ServicoAcolhimentoService from "../../../../../main/services/ServicoAcolhimentoService";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import SemRegistros from "../../../../components/SemRegistros";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { criancaFunc, servicos } from "../../../../../helpers/Funcionalidades";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import pt from "date-fns/locale/pt-BR";

const EditarGestao = () => {
  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  const { id } = useParams();
  const history = useHistory();
  const { setEditarGestaoServ } = useAppContext();
  const { roleKeycloack, user } = useAuthProvider();
  const suportedFormats = [
    ".png",
    ".bmp",
    ".tiff",
    ".jpg",
    ".jpeg",
    ".doc",
    ".docx",
    ".txt",
    ".dot",
    ".pdf",
    ".xml",
    ".xls",
    ".xlam",
    ".ods",
  ];

  const [dataSA, setDataSA] = useState();
  const [loadingSA, setLoadingSA] = useState(true);
  const [loadingGestao, setLoadingGestao] = useState(true);
  const [anexoEditadoEstatuto, setAnexoEditadoEstatuto] = useState(false);
  const [unfinishedEG, setUnfinishedEG] = useState(false);
  const [unfinishedSE, setUnfinishedSE] = useState(false);
  const [unfinishedSOGM, setUnfinishedSOGM] = useState(false);
  const [initialValues, setInitialValues] = useState({
    possuiEstatuto: "",
    anexoEstatuto: null,
    ultimaAtualizacaoEstatuto: "",
    possuiEntidadeGestora: "",
    entidadesGestoras: [
      {
        id: 0,
        nomeEntidade: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
    listaEntidadeGestora: [
      {
        id: 0,
        nomeEntidade: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
    possuiSupervisaoExterna: "",
    supervisoesExternas: [
      {
        id: 0,
        nomeEntidade: "",
        nomeSupervisor: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
    listaSupervisaoExterna: [
      {
        id: 0,
        nomeEntidade: "",
        nomeSupervisor: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
    possuiSupervisaoOGMunicipal: "",
    supervisoesOGMunicipal: [
      {
        id: 0,
        nomeSupervisor: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
    listaSupervisaoOrgaoGestor: [
      {
        id: 0,
        nomeSupervisor: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
  });

  useEffect(() => {
    ServicoAcolhimentoService.getServicoAcolhimento(id)
      .then((res) => {
        setDataSA(res.data);
        setLoadingSA(false);
      })
      .catch((err) => {
        console.log(err);
      });
    GestaoSAService.getGestaoSA(id)
      .then((res) => {
        const {
          anexoEstatuto,
          ultimaAtualizacaoEstatuto,
          listaEntidadeGestora,
          listaSupervisaoExterna,
          listaSupervisaoOrgaoGestor,
          servicoAcolhimento,
          id,
          possuiEntidadeGestora,
          possuiSupervisaoExterna,
          possuiSupervisaoOGMunicipal,
          ...resto
        } = res.data;

        let tempListaEntidadesGestoras = [
          {
            id: 0,
            nomeEntidade: "",
            dataInicio: "",
            dataFim: "",
          },
        ];
        let tempListaSupervisaoExterna = [
          {
            id: 0,
            nomeEntidade: "",
            nomeSupervisor: "",
            dataInicio: "",
            dataFim: "",
          },
        ];
        let tempListaSupervisaoOrgaoGestor = [
          {
            id: 0,
            nomeSupervisor: "",
            dataInicio: "",
            dataFim: "",
          },
        ];

        if (!anexoEstatuto) {
          setAnexoEditadoEstatuto(true);
        }

        if (listaEntidadeGestora?.length > 0) {
          setUnfinishedEG(checkUnfinished(listaEntidadeGestora, "dataFim"));
          tempListaEntidadesGestoras = remountObjects(listaEntidadeGestora, [
            "dataInicio",
            "dataFim",
          ]);
        } else {
          tempListaEntidadesGestoras = [
            { id: 0, nomeEntidade: "", dataInicio: "", dataFim: "" },
          ];
        }

        if (listaSupervisaoExterna?.length > 0) {
          setUnfinishedSE(checkUnfinished(listaSupervisaoExterna, "dataFim"));
          tempListaSupervisaoExterna = remountObjects(listaSupervisaoExterna, [
            "dataInicio",
            "dataFim",
          ]);
        } else {
          tempListaSupervisaoExterna = [
            {
              id: 0,
              nomeEntidade: "",
              nomeSupervisor: "",
              dataInicio: "",
              dataFim: "",
            },
          ];
        }

        if (listaSupervisaoOrgaoGestor?.length > 0) {
          setUnfinishedSOGM(
            checkUnfinished(listaSupervisaoOrgaoGestor, "dataFim")
          );
          tempListaSupervisaoOrgaoGestor = remountObjects(
            listaSupervisaoOrgaoGestor,
            ["dataInicio", "dataFim"]
          );
        } else {
          tempListaSupervisaoOrgaoGestor = [
            {
              id: 0,
              nomeSupervisor: "",
              dataInicio: "",
              dataFim: "",
            },
          ];
        }

        setInitialValues({
          ultimaAtualizacaoEstatuto: ultimaAtualizacaoEstatuto
            ? format(new Date(ultimaAtualizacaoEstatuto), "dd/MM/yyyy")
            : "",
          anexoEstatuto: null,
          anexo: anexoEstatuto,
          listaEntidadeGestora: tempListaEntidadesGestoras,
          listaSupervisaoExterna: tempListaSupervisaoExterna,
          listaSupervisaoOrgaoGestor: tempListaSupervisaoOrgaoGestor,
          possuiEntidadeGestora:
            listaEntidadeGestora?.length > 0 ? possuiEntidadeGestora : "N",
          possuiSupervisaoExterna:
            listaSupervisaoExterna?.length > 0 ? possuiSupervisaoExterna : "N",
          possuiSupervisaoOGMunicipal:
            listaSupervisaoOrgaoGestor?.length > 0
              ? possuiSupervisaoOGMunicipal
              : "N",
          ...resto,
        });
        setLoadingGestao(false);
      })
      .catch((error) => console.log(error));
  }, [id]);

  const checkUnfinished = (obj, fieldName) => {
    const tempObj = obj.filter((objeto) => !objeto[fieldName]);
    return tempObj.length > 0;
  };

  const remountObjects = (obj, fields) => {
    const mountedArray = obj.map((objeto) => {
      const tempObj = {};
      for (let key in objeto) {
        if (fields.includes(key)) {
          if (objeto[key]) {
            tempObj[key] = format(new Date(objeto[key]), "dd/MM/yyyy");
          } else {
            tempObj[key] = "";
          }
        } else {
          tempObj[key] = objeto[key];
        }
      }
      return tempObj;
    });
    return mountedArray;
  };

  const handleDateParse = (obj, fields = ["dataInicio", "dataFim"]) => {
    const mountedArray = obj.map((objeto) => {
      const tempObj = {};
      for (let key in objeto) {
        if (fields.includes(key)) {
          if (objeto[key]) {
            tempObj[key] = parse(
              objeto[key],
              "dd/MM/yyyy",
              new Date()
            ).toISOString();
          } else {
            tempObj[key] = null;
          }
        } else {
          tempObj[key] = objeto[key];
        }
      }
      return tempObj;
    });
    return mountedArray;
  };

  const schema = Yup.object().shape({
    possuiEstatuto: Yup.string()
      .nullable()
      .test(
        "estatutoObrigatorio",
        "Este campo é obrigatório!",
        (value, context) => {
          if (dataSA) {
            if (dataSA.naturezaServico === "privada") {
              return !!value;
            } else {
              return true;
            }
          } else {
            return false;
          }
        }
      ),
    anexoEstatuto: Yup.mixed().when("possuiEstatuto", {
      is: (possui) =>
        possui
          ? possui === "S" &&
            anexoEditadoEstatuto &&
            dataSA.naturezaServico === "privada"
          : false,
      then: Yup.mixed()
        .required("Este campo é obrigatório!")
        .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
          if (value === null) {
            return true;
          } else {
            return value.size <= 10000000;
          }
        })
        .test("fileType", "Anexar uma extensão válida.", (value) => {
          if (value === null) {
            return true;
          } else {
            let haveFormat = false;
            suportedFormats.forEach((format) => {
              if (value.path.toString().toLowerCase().includes(format)) {
                haveFormat = true;
              }
            });
            return haveFormat;
          }
        }),
    }),
    ultimaAtualizacaoEstatuto: Yup.string()
      .nullable()
      .when("possuiEstatuto", {
        is: (possui) =>
          possui
            ? possui === "S" && dataSA.naturezaServico === "privada"
            : false,
        then: Yup.string("Este campo é obrigatório!")
          .nullable()
          .required("Este campo é obrigatório!")
          .test(
            "dataAtualizacaoAfterToday",
            "A data informada não pode ser uma data futura!",
            (value) => {
              if (value === null) {
                return false;
              } else {
                return !isAfter(
                  parse(value, "dd/MM/yyyy", new Date()),
                  new Date()
                );
              }
            }
          )
          .test("validDate", "Data inválida!", (value) => {
            if (!!value) {
              if (value.length === 10) {
                return isValid(parse(value, "dd/MM/yyyy", new Date()));
              } else {
                return false;
              }
            } else {
              return false;
            }
          }),
      }),
    possuiEntidadeGestora: Yup.string("Este campo é obrigatório!").required(
      "Este campo é obrigatório!"
    ),
    listaEntidadeGestora: Yup.mixed().when("possuiEntidadeGestora", {
      is: (possui) => (possui ? possui === "S" : false),
      then: Yup.array().of(
        Yup.object().shape({
          nomeEntidade: Yup.string("Este campo é obrigatório!")
            .required("Este campo é obrigatório!")
            .trim("Este campo é obrigatório!"),
          dataInicio: Yup.string("Este campo é obrigatório!")
            .nullable()
            .required("Este campo é obrigatório!")
            .test(
              "dataAfterToday",
              "A data informada não pode ser uma data futura!",
              (value) => {
                if (value === null) {
                  return false;
                } else {
                  return !isAfter(
                    parse(value, "dd/MM/yyyy", new Date()),
                    new Date()
                  );
                }
              }
            )
            .test("validDate", "Data inválida!", (value) => {
              if (!!value) {
                if (value.length === 10) {
                  return isValid(parse(value, "dd/MM/yyyy", new Date()));
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }),
          dataFim: Yup.string()
            .nullable()
            .when("dataInicio", (dataInicio, schema) => {
              return schema
                .test(
                  "dataBeforeInicio",
                  "Data de fim não pode ser anterior ao início!",
                  (value) => {
                    if (!Boolean(value)) {
                      return true;
                    } else {
                      return !isBefore(
                        parse(value, "dd/MM/yyyy", new Date()),
                        parse(dataInicio, "dd/MM/yyyy", new Date())
                      );
                    }
                  }
                )
                .test("validDate", "Data inválida!", (value) => {
                  if (!!value) {
                    if (value.length === 10) {
                      return isValid(parse(value, "dd/MM/yyyy", new Date()));
                    } else {
                      return false;
                    }
                  } else {
                    return true;
                  }
                });
            }),
        })
      ),
    }),
    possuiSupervisaoExterna: Yup.string("Este campo é obrigatório!").required(
      "Este campo é obrigatório!"
    ),
    listaSupervisaoExterna: Yup.mixed().when("possuiSupervisaoExterna", {
      is: (possui) => (possui ? possui === "S" : false),
      then: Yup.array().of(
        Yup.object().shape({
          nomeEntidade: Yup.string("Este campo é obrigatório!")
            .required("Este campo é obrigatório!")
            .trim("Este campo é obrigatório!"),
          nomeSupervisor: Yup.string("Este campo é obrigatório!")
            .required("Este campo é obrigatório!")
            .trim("Este campo é obrigatório!"),
          dataInicio: Yup.string("Este campo é obrigatório!")
            .nullable()
            .required("Este campo é obrigatório!")
            .test(
              "dataAfterToday",
              "A data informada não pode ser uma data futura!",
              (value) => {
                if (value === null) {
                  return false;
                } else {
                  return !isAfter(
                    parse(value, "dd/MM/yyyy", new Date()),
                    new Date()
                  );
                }
              }
            )
            .test("validDate", "Data inválida!", (value) => {
              if (!!value) {
                if (value.length === 10) {
                  return isValid(parse(value, "dd/MM/yyyy", new Date()));
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }),
          dataFim: Yup.string()
            .nullable()
            .when("dataInicio", (dataInicio, schema) => {
              return schema
                .test(
                  "dataBeforeInicio",
                  "Data de fim não pode ser anterior ao início!",
                  (value) => {
                    if (!Boolean(value)) {
                      return true;
                    } else {
                      return !isBefore(
                        parse(value, "dd/MM/yyyy", new Date()),
                        parse(dataInicio, "dd/MM/yyyy", new Date())
                      );
                    }
                  }
                )
                .test("validDate", "Data inválida!", (value) => {
                  if (!!value) {
                    if (value.length === 10) {
                      return isValid(parse(value, "dd/MM/yyyy", new Date()));
                    } else {
                      return false;
                    }
                  } else {
                    return true;
                  }
                });
            }),
        })
      ),
    }),
    possuiSupervisaoOGMunicipal: Yup.string(
      "Este campo é obrigatório!"
    ).required("Este campo é obrigatório!"),
    listaSupervisaoOrgaoGestor: Yup.mixed().when(
      "possuiSupervisaoOGMunicipal",
      {
        is: (possui) => (possui ? possui === "S" : false),
        then: Yup.array().of(
          Yup.object().shape({
            nomeSupervisor: Yup.string("Este campo é obrigatório!")
              .required("Este campo é obrigatório!")
              .trim("Este campo é obrigatório!"),
            dataInicio: Yup.string("Este campo é obrigatório!")
              .nullable()
              .required("Este campo é obrigatório!")
              .test(
                "dataAfterToday",
                "A data informada não pode ser uma data futura!",
                (value) => {
                  if (value === null) {
                    return false;
                  } else {
                    return !isAfter(
                      parse(value, "dd/MM/yyyy", new Date()),
                      new Date()
                    );
                  }
                }
              )
              .test("validDate", "Data inválida!", (value) => {
                if (!!value) {
                  if (value.length === 10) {
                    return isValid(parse(value, "dd/MM/yyyy", new Date()));
                  } else {
                    return false;
                  }
                } else {
                  return false;
                }
              }),
            dataFim: Yup.string()
              .nullable()
              .when("dataInicio", (dataInicio, schema) => {
                return schema
                  .test(
                    "dataBeforeInicio",
                    "Data de fim não pode ser anterior ao início!",
                    (value) => {
                      if (!Boolean(value)) {
                        return true;
                      } else {
                        return !isBefore(
                          parse(value, "dd/MM/yyyy", new Date()),
                          parse(dataInicio, "dd/MM/yyyy", new Date())
                        );
                      }
                    }
                  )
                  .test("validDate", "Data inválida!", (value) => {
                    if (!!value) {
                      if (value.length === 10) {
                        return isValid(parse(value, "dd/MM/yyyy", new Date()));
                      } else {
                        return false;
                      }
                    } else {
                      return true;
                    }
                  });
              }),
          })
        ),
      }
    ),
  });

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        possuiEstatuto,
        possuiEntidadeGestora,
        possuiSupervisaoExterna,
        possuiSupervisaoOGMunicipal,
        entidadesGestoras,
        listaEntidadeGestora,
        supervisoesExternas,
        listaSupervisaoExterna,
        supervisoesOGMunicipal,
        listaSupervisaoOrgaoGestor,
        ultimaAtualizacaoEstatuto,
        anexo,
        ...resto
      } = values;

      const valuesToSend =
        dataSA.naturezaServico === "publica"
          ? {
              possuiEntidadeGestora,
              possuiSupervisaoExterna,
              possuiSupervisaoOGMunicipal,
              entidadesGestoras:
                possuiEntidadeGestora === "S"
                  ? JSON.stringify(
                      handleDateParse(listaEntidadeGestora, [
                        "dataInicio",
                        "dataFim",
                      ])
                    )
                  : "",
              listaEntidadeGestora:
                possuiEntidadeGestora === "S"
                  ? JSON.stringify(
                      handleDateParse(listaEntidadeGestora, [
                        "dataInicio",
                        "dataFim",
                      ])
                    )
                  : "",
              supervisoesExternas:
                possuiSupervisaoExterna === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoExterna))
                  : "",
              listaSupervisaoExterna:
                possuiSupervisaoExterna === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoExterna))
                  : "",
              supervisoesOGMunicipal:
                possuiSupervisaoOGMunicipal === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoOrgaoGestor))
                  : "",
              listaSupervisaoOrgaoGestor:
                possuiSupervisaoOGMunicipal === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoOrgaoGestor))
                  : "",
              ...resto,
            }
          : {
              anexoEditadoEstatuto,
              possuiEstatuto,
              possuiEntidadeGestora,
              possuiSupervisaoExterna,
              possuiSupervisaoOGMunicipal,
              entidadesGestoras:
                possuiEntidadeGestora === "S"
                  ? JSON.stringify(handleDateParse(listaEntidadeGestora))
                  : "",
              listaEntidadeGestora:
                possuiEntidadeGestora === "S"
                  ? JSON.stringify(handleDateParse(listaEntidadeGestora))
                  : "",
              supervisoesExternas:
                possuiSupervisaoExterna === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoExterna))
                  : "",
              listaSupervisaoExterna:
                possuiSupervisaoExterna === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoExterna))
                  : "",
              supervisoesOGMunicipal:
                possuiSupervisaoOGMunicipal === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoOrgaoGestor))
                  : "",
              listaSupervisaoOrgaoGestor:
                possuiSupervisaoOGMunicipal === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoOrgaoGestor))
                  : "",
              ultimaAtualizacaoEstatuto: ultimaAtualizacaoEstatuto
                ? parse(
                    ultimaAtualizacaoEstatuto,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              ...resto,
            };

      GestaoSAService.atualizarGestaoSA(id, valuesToSend)
        .then((res) => {
          Swal.fire({
            title: "Sucesso!",
            text: "Registro atualizado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            history.goBack();
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (error.response.data.field === "Gestao") {
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message,
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  }).then(() => {
                    history.push(
                      "/servico-acolhimento/visualizar-gestao/" + id
                    );
                  });
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    actions.setFieldError(key.toString(), errors[key]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
          actions.setSubmitting(false);
        });
    }, 200);
  };

  return roleKeycloack &&
    (roleKeycloack.includes(servicos.gestaoEditar) ||
      (roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) &&
        user?.orgaoExterno?.includes(Number(dataSA?.idPessoaJuridica)))) ? (
    !loadingGestao && !loadingSA ? (
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
      >
        {(props) => (
          <Form>
            {setEditarGestaoServ(hasFormChanged(initialValues, props.values))}
            {dataSA.naturezaServico === "privada" && (
              <EstatutoEntidade
                formProps={props}
                anexoEditado={anexoEditadoEstatuto}
                setAnexoEditado={setAnexoEditadoEstatuto}
              />
            )}
            <EntidadeGestora formProps={props} hasUnfinished={unfinishedEG} />
            <SupervisaoExterna formProps={props} hasUnfinished={unfinishedSE} />
            <SupervisaoOGMunicipal
              formProps={props}
              hasUnfinished={unfinishedSOGM}
            />
            <Flex mt="30px" justifyContent="flex-end">
              <Button
                id="button-salvar"
                type="submit"
                translate="no"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                w="17%"
                isLoading={props.isSubmitting}
              >
                Salvar
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default EditarGestao;
